<template>
    <div id="app" v-cloak>
        <div class="row no-gutters">
            <div class="col-12 col-lg-5 px-5 pt-2">
                <div class="col-12 row my-3">
                    <a :href="return_route" class="mr-auto ml-3 my-1">
                        <button class="btn btn-default float-right" type="button">{{ $lang('Wróć') }}</button>
                    </a>
                    <button type="button" class="btn btn-primary ml-auto my-1"
                            data-toggle="modal" :data-target="'#'+sliderImagesModalId">
                        {{ $lang('Zdjęcia') }}
                    </button>

                    <button type="button" class="btn btn-primary ml-3 my-1"
                            data-toggle="modal" data-target="#new_slider" data-backdrop="static">
                        {{ $lang('Nowa reklama') }}
                    </button>
                </div>

                <new-slider-modal
                    :create_url="create_route"
                    :images="imagesData"
                ></new-slider-modal>
                <edit-slider-modal
                    :edit_url="update_route"
                    :slider=editedSlider
                    :images="imagesData"
                ></edit-slider-modal>
                <delete-slider-modal
                    :delete_url="delete_route"
                    :slider="editedSlider"
                ></delete-slider-modal>
                <slider-images-modal
                    v-model="imagesData"
                    :modal-id="sliderImagesModalId"
                    :upload-image-route="upload_image_route"
                    :delete-image-route="delete_image_route"
                ></slider-images-modal>

                <div class="form-row col-12">
                    <draggable v-model="slidersArray" group="Reklamy" @start="drag=true" @end="drag=false"
                               class="col-12" style="white-space: pre-wrap">
                        <div v-for="slider in slidersArray" class="card col-12 p-0 mt-3">
                            <div class="card-header pt-1 pb-1">
                                <div class="row">
                                    <div class="pull-right col-12">
                                        <div class="row">
                                            <div class="ml-2">
                                                <i :class="(slider.active==true ? 'fa-check-circle-o' : 'fa-times-circle-o')
                                                 + ' fa icon fa-lg ' " aria-hidden="true"></i>
                                            </div>
                                            <div class="ml-auto mr-4">
                                                <i class="fa fa-trash tile icon fa-lg print" v-if="sliders.length>1"
                                                   data-toggle="modal" data-target="#delete_slider"
                                                   data-backdrop="static" aria-hidden="true"
                                                   @click="editedSlider=slider"></i>
                                            </div>
                                            <div class="mr-2">
                                                <i class="fa fa-pencil tile icon fa-lg print" aria-hidden="true"
                                                   data-toggle="modal" data-target="#edit_slider"
                                                   data-backdrop="static"
                                                   @click="editedSlider=slider"></i>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="card-body row">
                                <div class="col-12 col-md-10">
                                    <strong>{{ slider.header }}</strong>
                                    <p v-html="slider.description" class="text-justify m-0 p-0">
                                        {{ slider.description }}</p>
                                    <p class="text-right m-0 p-0"><strong>{{ slider.footer }}</strong></p>
                                    <a v-if="slider.button" :href="slider.url" target="_blank">
                                        <button class="btn btn-primary pull-right mt-2">{{ slider.button }}</button>
                                    </a>
                                </div>
                                <div class="col-12 col-md-2">
                                    <img :src="slider.img" style="width: 100%">
                                </div>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
            <div class="d-none d-lg-block col-lg-7 p-0 m-0" style="height: 100vh">
                <login-carousel
                    :elements="slidersArray"
                    :carousel_element_view="carousel_element_view"
                ></login-carousel>
            </div>
        </div>
    </div>
</template>

<script>
import EditSliderModal from "./edit-slider-modal";
import NewSliderModal from "./new-slider-modal";
import Draggable from 'vuedraggable'
import ShowNotification from "../../mixins/show-notification";
import DeleteSliderModal from "./delete-slider-modal";
import SliderImagesModal from "./slider-images-modal.vue";

export default {
    mixins: [ShowNotification],
    name: "sliders-index",
    components: {DeleteSliderModal, EditSliderModal, NewSliderModal, Draggable, SliderImagesModal},
    props: {
        return_route: String,
        sliders: Array,
        images: Array,
        create_route: String,
        update_route: String,
        delete_route: String,
        order_route: String,
        upload_image_route: String,
        delete_image_route: String,
        carousel_element_view: String
    },
    data() {
        return {
            editedSlider: null,
            slidersArray: this.sliders,
            uploadedImage: null,
            imagesData: this.images,
            sliderImagesModalId: 'slider-images-modal'
        }
    },
    methods: {
        saveOrder() {
            axios.post(this.order_route, {
                array: this.slidersArray
            })
                .catch(function (error) {
                    console.log(error)
                });
        },
    },
    watch: {
        slidersArray: {
            deep: true,
            handler() {
                this.saveOrder();
            }
        }
    }
}
</script>
